import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {PatronBalanceTransaction} from '@store/account/account.types';
import {AccountSelectors} from '@store/store.selectors';

@Component({
  selector: 'rn-expanded-transaction-amounts',
  template: `
    @for (balanceLine of transactionSelectors.sortedBalanceLinesFor(transaction) | select; track balanceLine.id) {
      <div class="expansion-row-content" rnTruncate>
        {{ transactionLineSelectors.amountFor(balanceLine) | select | format:'CURRENCY' }}
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExpandedTransactionAmountsComponent {

  @Input() transaction: PatronBalanceTransaction;

  public readonly transactionSelectors = AccountSelectors.BalanceTransactions;
  public readonly transactionLineSelectors = AccountSelectors.BalanceTransactionLines;
}
